let brands = $('.brands');
let categories = brands.find('.brands__cats');
let slides = brands.find('.swiper-slide');
let currentBrand = null;
const currentLocation = window.location.href;

// eslint-disable-next-line no-unused-vars,no-undef
let brandsSlider = new Swiper('.brandsSwiper', {
	slidesPerView: 3,
	slidesPerColumn: 3,
	spaceBetween: 10,
	pagination: {
		el: '.brands .swiper-pagination',
		clickable: true,
	},
	breakpoints: {
		480: {
			slidesPerView: 4,
			slidesPerColumn: 3,
			spaceBetween: 20,
		},
		768: {
			slidesPerView: 5,
			slidesPerColumn: 2,
			spaceBetween: 30,
		},
	},
});

let setCurrentBrand = () => {
	currentBrand = null;
	$('.swiper-slide[data-target="#brandModal"]').on('click', (e) => {
		currentBrand = $(e.currentTarget).data('brand');
	});
};
setCurrentBrand();

let setVisibleSlides = (e) => {
	let categoryId = Number(e.target.dataset.id);
	brandsSlider.removeAllSlides();
	for (let i = 0; i < brandsSlides.length; i++) {
		if (brandsSlides[i].terms.includes(categoryId)) {
			brandsSlider.prependSlide(
				`<div class="swiper-slide" data-brand="${brandsSlides[i].id}" data-toggle="modal" data-target="#brandModal"><div class="imagebg" style="background-image:url(${brandsSlides[i].img})"></div></div>`,
				/*`<div class="swiper-slide" data-brand="${brandsSlides[i].id}" data-toggle="modal" data-target="#brandModal"><picture><img src="${brandsSlides[i].img}"></picture></div>`,*/
			);
		}
	}

	brandsSlider.update();
	brandsSlider.slideTo(1);
	setCurrentBrand();
};

categories.on('click', 'li', (e) => {
	setVisibleSlides(e);
	categories.find('li').removeClass();
	$(e.currentTarget).addClass('active');
});

$('#brandModal')
.on('show.bs.modal', () => {
	$('#brand-modal-content').html('<div class="text-center"><div class="spinner-border text-success" role="status"><span class="sr-only">Loading...</span></div></div>');
	$.get(`${themeData.api}brands/${currentBrand}`)
		.done((response) => {
			$('#brand-modal-content').html(response.html);
			setCurrentBrand();
			history.pushState({brand_id: currentBrand}, '', response.url)
		});
})
.on('hide.bs.modal', () => {
	let html = `<div class="text-center">
		<div class="spinner-border text-success" role="status">
			<span class="sr-only">Loading...</span>
		</div>
	</div>`;
	$('#brand-modal-content').html(html);
	history.pushState({}, '', currentLocation)
});
